import { render, staticRenderFns } from "./Clearance.vue?vue&type=template&id=4f313271"
import script from "./Clearance.vue?vue&type=script&lang=js"
export * from "./Clearance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports